<template>
    <div class="wout-login">
        <div class="center">
            <div>
                <img src="@/assets/img/proxima.svg" 
                    width="auto" height="130" alt="Próxima!" crossorigin />
            </div>
            <span class="proxima">Na sua próxima compra, entre em contato com a gente!</span>
        </div>
    </div>
</template>
<script>

export default {
    data: () => {
        return {
            
        }
    }
}
</script>

<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
}
.proxima {
    font-weight: normal;
    color: white!important;
    padding: 5px;
    width: 60vw;
    text-align: center;
}
</style>